export const allUsers = [
  {
    id: 1,
    username: 'amar',
    password: 'amar123',
  },
  {
    id: 2,
    username: 'akbar',
    password: 'akbar123',
  },
  {
    id: 3,
    username: 'antony',
    password: 'antony123',
  },
  {
    id: 4,
    username: 'john',
    password: 'john123',
  },
  {
    id: 5,
    username: 'paul',
    password: 'paul123',
  },
];
